
import React, { useEffect, useState, useContext, useMemo, useCallback, Fragment } from "react";
import { StyledTableAprovacoes } from "../../styled-components/StyledTableAprovacoes.style";
import { StyledTablePage } from "../../styled-components/StyledTablePage.style";
import { useTable, useSortBy, useFilters, useColumnOrder } from "react-table";
import IntlCurrencyInput from "react-intl-currency-input";
import { Link } from "react-router-dom";
import Flex from '@react-css/flex';
import api from '../../services/api';
import { ModalTimesheetFinalizar } from "../ModalTimesheetFinalizar";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { IconTable } from "../../svg";

import { createGlobalStyle } from 'styled-components';

const CustomCheckboxStyle = createGlobalStyle`
  input[type="checkbox"] {
    width: 18px;
    height: 18px;
    appearance: none;
    -webkit-appearance: none;
    background-color: #fff;
    border: 2px solid #cac6c6;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.2s ease;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    vertical-align: middle;
  }

  input[type="checkbox"]:checked {
    background-color: #cac6c6;
    border-color: #cac6c6;
  }

  input[type="checkbox"]:checked::after {
    content: '';
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
    display: inline-block;
  }
`;

const currencyConfig = {
    locale: "pt-BR",
    formats: {
        number: {
            BRL: {
                style: "currency",
                currency: "BRL",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            },
        },
    },
};

const deafultOrderColumns = [
    "ac",
    "sigla",
    "timeSheetSigla",
    "dataTimesheet",
    "lider",
    "analista",
    "cliente.clienteNome",
    "nomeEtapa",
    "segurado.seguradoNome",
    "statusTimesheet",
    "tipoTimesheet",
    "horasTimeSheet",
    "valorTimesheet"
];

let checkedList = []; // Para controlar os checkboxes

export const TableAprovacoes = (props) => {
    const {
        listaAprovacoes,
        aprovacaoEmMassa,
        clearCheckedList,
        setAprovacaoEmMassaList,
        openModalAprovacaoEmMassa,
        openModalAprovar,
        openModalReprovar,
        openModalCancelar,
        openModalTransferir,
        openModalConcluir,
        openHistoricoAprovacoesModal,
        openObservacoesTimesheet,
        openModalASolicitarEsclarecimento,
        openModalTimesheetTimeline,
        openModalVincular,
        openModalTimeSheetExportarPDF
    } = props;

    var [listTsTable, setListTsTable] = useState([]);
    var [columns, setColumns] = useState([]);
    const [modalTimeshetFinalizarIsOpen, setModalTimeshetFinalizarIsOpen] = useState(false);
    const [finalizarResumo, setFinalizarResumo] = useState({});
    const [timesheet, setTimesheet] = useState({});
    const [finalizarResumoAccess, setFinalizarResumoAccess] = useState({});
    const [checkAll, setCheckAll] = useState(false);
    const [modalTimelineIsOpen, setmodalTimelineIsOpen] = useState(false);

    const closeModalTimesheetFinalizar = () => {
        setModalTimeshetFinalizarIsOpen(false);
    }

    const config = {
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Credentials': false
        }
    }

    const ColumnFilter = ({ column }) => {
        const { filterValue, setFilter, filter, inputFilterClass } = column;
        return (
            <input
                value={filterValue || ""}
                onChange={e => {
                    setFilter(e.target.value || undefined);
                }}
                placeholder={`Filtrar`}
                className={`width-${inputFilterClass}`}
            />
        );
    };

    const MoneyColumnFilter = ({ column }) => {
        const { filterValue, setFilter, filter, inputFilterClass } = column;

        return (
            <IntlCurrencyInput
                currency="BRL"
                config={currencyConfig}
                defaultValue={filterValue || ""}
                onChange={(_event, value, _maskedValue) => {
                    setFilter(value || undefined);
                }}
                style={{
                    width: `${inputFilterClass}px`,
                    marginRight: '10px',
                    textAlign: "right"
                }}
            />
        );
    };

    const StartStringColumnFilter = ({ column }) => {
        const { filterValue, setFilter, filter, inputFilterClass } = column;
        return (
            <input
                value={filterValue || ""}
                onChange={e => {
                    setFilter(e.target.value || undefined);
                }}
                placeholder={`Filtrar`}
                className={`width-${inputFilterClass}`}
            />
        );
    };

    const removerAcentosEEspeciais = (texto) => {
        if (!texto) {
            return "";
        }

        return texto.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
    }

    const startsWith = (rows, ids, filterValue) => {
        rows = rows.filter((row) => {
            return ids.some((id) => {
                const rowValue = row.values[id];

                const texto1Limpo = removerAcentosEEspeciais(rowValue);
                const texto2Limpo = removerAcentosEEspeciais(filterValue);

                return texto1Limpo.startsWith(texto2Limpo);
            });
        });
        return rows;
    }

    const MoneyRangeColumnFilter = ({ column: { filterValue = [], preFilteredRows, setFilter, id }, }) => {
        const [min, max] = useMemo(() => {
            let min = preFilteredRows.length ? preFilteredRows[0].values[id] : 0
            let max = preFilteredRows.length ? preFilteredRows[0].values[id] : 0
            preFilteredRows.forEach(row => {
                min = Math.min(row.values[id], min)
                max = Math.max(row.values[id], max)
            })
            return [min, max]
        }, [id, preFilteredRows])

        return (
            <div
                style={{
                    display: 'flex',
                }}
            >
                <IntlCurrencyInput
                    currency="BRL"
                    config={currencyConfig}
                    defaultValue={filterValue[0] || ''}
                    onChange={(_event, value, _maskedValue) => {
                        setFilter((old = []) => [value ? value : undefined, old[1]])
                    }}
                    style={{
                        width: '100px',
                        marginRight: '10px',
                        textAlign: "right"
                    }}
                />
                <div className="pt-2">Até</div>
                <IntlCurrencyInput
                    currency="BRL"
                    config={currencyConfig}
                    defaultValue={filterValue[1] || ''}
                    onChange={(_event, value, _maskedValue) => {
                        setFilter((old = []) => [old[0], value ? value : undefined])
                    }}
                    style={{
                        width: '100px',
                        marginLeft: '10px',
                        textAlign: "right"
                    }}
                />
            </div>
        )
    }

    const NumberRangeColumnFilter = ({ column: { filterValue = [], preFilteredRows, setFilter, id }, }) => {
        const [min, max] = useMemo(() => {
            let min = preFilteredRows.length ? preFilteredRows[0].values[id] : 0
            let max = preFilteredRows.length ? preFilteredRows[0].values[id] : 0
            preFilteredRows.forEach(row => {
                min = Math.min(row.values[id], min)
                max = Math.max(row.values[id], max)
            })
            return [min, max]
        }, [id, preFilteredRows])

        return (
            <div
                style={{
                    display: 'flex',
                }}
            >
                <input
                    value={filterValue[0] || ''}
                    type="number"
                    onChange={e => {
                        const val = e.target.value
                        setFilter((old = []) => [val ? parseInt(val, 10) : undefined, old[1]])
                    }}
                    placeholder={`Min`}
                    style={{ width: '80px', marginRight: '10px' }}
                />
                <div className="pt-2">Até</div>
                <input
                    value={filterValue[1] || ''}
                    type="number"
                    onChange={e => {
                        const val = e.target.value
                        setFilter((old = []) => [old[0], val ? parseInt(val, 10) : undefined])
                    }}
                    placeholder={`Max`}
                    style={{ width: '80px', marginLeft: '10px' }}
                />
            </div>
        )
    }

    const formatDecimal = (value) => {
        if (value == null || value === undefined || value === 0) {
            return '0,00';
        }

        return value.toLocaleString('pt-br', { style: 'decimal', currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    const convertDecimal = (value) => {
        if (value == null || value === undefined || value === 0) {
            return 0;
        }

        const newValue = value.replace('R$', '').replace(/\./g, '').replace(',', '.');
        return isNaN(newValue) ? 0 : parseFloat(newValue);
    }

    const filterAcoes = ({ column }) => {
        const { filterValue, setFilter, filter, inputFilterClass } = column;

        return (
            null
        );


    };

    const openPlanilhaResumo = async (item) => {
        try {
            const responseTS = await api.get(`Timesheet/load/${item.idTimesheet}?length=10`, config);
            setTimesheet(responseTS.data.data);
            const response = await api.get(`timesheet/${item.idTimesheet}/finalizar`, config);
            setFinalizarResumo(response.data.data);
            setFinalizarResumoAccess(response.data.access);
            setModalTimeshetFinalizarIsOpen(true);
        } catch (err) { }
    }

    const getTimelineClasse = (idTimesheet, random) => {
        return `datas-${idTimesheet}-${random}`;
    }

    const getacoes = (props) => {
        const row = props.row.original;
        let dadosUsuario = JSON.parse(localStorage.getItem("PROFILE_DATA_SISCOPE"));

        return (
            <Flex.Item className="flex-column-right-num-ts header-items">
                { row?.acoes?.aprovacaoEmMassa && row.statusAprovacao === 'Pendente' && row.escalrecimentosEmAberto === 0 &&
                    row?.acoes?.aprovar && !row.acoes.notificacaoAtividade && !row?.acoes?.notificacaoGrupoAtividade && (
                        <Fragment key={row.idPendenciaAprovacao}>
                            <CustomCheckboxStyle />
                            <input
                                type="checkbox"
                                checked={isChecked(row.idPendenciaAprovacao)}
                                onChange={(e) => onChangeSetAprovacaoEmMassa(e.target.checked, row)}
                                title="Selecionar"
                            />
                        </Fragment>
                    )
                }
                <a className="menu-link hover">
                    <i className="fa fa-calendar" onClick={() => openModalTimesheetTimeline(row)}>
                    </i>
                </a>
                <a className="menu-link hover" onClick={() => openModalASolicitarEsclarecimento(row)} title="Esclarecimentos">
                    <i className={row.escalrecimentosEmAberto > 0 ? (row.idusuarioUltimaMsgEscalrecimento == dadosUsuario.idUsuario ? "fa fa-list-ol possui-comentarios" : "fa fa-list-ol possui-comentarios resposta-pendente") : "fa fa-list-ol"}></i>
                </a>
                <a className="menu-link hover" onClick={() => openHistoricoAprovacoesModal(row)} title="Histórico de Aprovações">
                    <i className="fa fa-history" aria-hidden="true"></i>
                </a>
                <a className="menu-link hover" onClick={() => openModalTransferir(row)} title="Transferir aprovação para outro usuário">
                    <i className="fa fa-exchange"></i>
                </a>
                <a className="menu-link hover" onClick={() => openObservacoesTimesheet(row.idTimesheet)} title="Observações">
                    <i className={row.quantidadeComentarios > 0 ? "fa fa-comments-o possui-comentarios" : "fa fa-comments-o"}></i>
                </a>
                <Link className="menu-link" to={{ pathname: "/timesheetdetalhespage/", hash: row.idTimesheet }} title="Detalhes do Timesheet">
                    <i className="fa fa-search"></i>
                </Link>

                <a className="menu-link hover" onClick={() => openPlanilhaResumo(row)} title="Planilha Resumo">
                    <i className="fa fa-file-text-o"></i>
                </a>

                {row.acoes.vincular && (
                    <a className="menu-link hover" onClick={() => openModalVincular(row)} title="Vincular">
                        <i className="fa fa-link"></i>
                    </a>
                )}

                <a className="menu-link hover" onClick={() => openModalTimeSheetExportarPDF(row)} title="Exportar PDF">
                    <i className="fa fa-file"></i>
                </a>

                {
                    row.statusAprovacao == 'Pendente' && row.escalrecimentosEmAberto == 0 && (
                        < >
                            {
                                row.acoes.reprovar && (
                                    <a className="menu-link hover text-error" onClick={() => openModalReprovar(row)} title="Reprovar">
                                        <i className="fa fa-times-circle-o"></i>
                                    </a>
                                    // <input className='default-button-red button-reprovar' value='Reprovar' type="button" onClick={() => openModalReprovar(row)} />
                                )
                            }
                            {
                                (row?.acoes?.aprovar && (!row.acoes.notificacaoAtividade && !row?.acoes?.notificacaoGrupoAtividade)) && (
                                    <a className="menu-link hover text-success" onClick={() => openModalAprovar(row)} title="Aprovar">
                                        <i className="fa fa-check-circle-o"></i>
                                    </a>
                                    // <input style={{ marginRight: "10px" }} className='default-button-red button-aprovar' value='Aprovar' type="button" onClick={() => openModalAprovar(row)} />
                                )
                            }
                            {
                                row?.acoes?.concluir && (
                                    <a className="menu-link hover text-primary" onClick={() => openModalConcluir(row)} title="Concluir">
                                        <i className="fa fa-check-square-o"></i>
                                    </a>

                                    // <input style={{ marginRight: "10px" }} className='default-button-red button-concluir' value='Concluir' type="button" onClick={() => openModalConcluir(row)} />
                                )
                            }
                        </>
                    )
                }
            </Flex.Item>
        );

    };

    const checkPrazo = (item) => {
        if (item.statusAprovacao !== "Pendente") return ""
        var diasPassadosEmPorcentagem = item.diasRestantes * 100 / item.prazo
        if (item.diasRestantes < 0) {
            return "error";
        }
        else if (diasPassadosEmPorcentagem <= 70) {
            return "warning";
        }
        else {
            return "success";
        }
    }

    const getTooltipData = (row) => {
        return `${row.diasRestantes} dias - ${row.diasRestantes < 0 ? "Atrasado" : row.diasRestantes + " dias restantes"}`;
    }

    const getConfData = (row) => {


        return (

            <span className={"legend-time prazo-" + checkPrazo(row)}
                title={getTooltipData(row)}
            >
                {row.dataPrazo} <i className="fa fa-circle" aria-hidden="true"></i>
            </span>

            // <div className="text-left">
            //     <span className="badge badge-secondary">{row.diasRestantes} dias</span>
            //     <span className={`badge badge-${checkPrazo(row)}`}>{row.diasRestantes < 0 ? "Atrasado" : row.diasRestantes + " dias restantes"}</span>
            // </div>
        );
    }

    columns = useMemo(
        () => [
            {
                Header: "Ações",
                accessor: "ac",
                className: "text-left",
                inputFilterClass: "80",
                width: "100px",
                sortDescFirst: true,
                Cell: (props) => {
                    return getacoes(props);
                },
                Filter: filterAcoes,
            },
            {
                Header: "Laudo",
                accessor: "sigla",
                className: "text-center",
                sortDescFirst: true,
                inputFilterClass: "60",
                Cell: (props) => {
                    return (props.row.original.acoes.indicacao ? <span className="indicacaoCheck" >{props.row.original.sigla}</span> : <>{props.row.original.sigla}</>)
                }
            },
            {
                Header: "TS",
                accessor: "timeSheetSigla",
                className: "text-center",
                classNameFooter: "text-center legend-value",
                inputFilterClass: "60",
                sortDescFirst: true,

            },
            {
                Header: "Vida Útil",
                accessor: "vidaUtil",
                className: "text-center",
                inputFilterClass: "60",
                sortDescFirst: true,
                Cell: (props) => {
                    return (<span className="badge bg-lightblue" >{props.row.original.vidaUtil}</span>)
                }
            },
            {
                Header: "Data",
                accessor: "dataTimesheet",
                className: "text-center",
                inputFilterClass: "80",
                sortDescFirst: true,
                Cell: (props) => {
                    return getConfData(props.row.original);
                },
                sortType: (a, b) => {
                    const parseDMY = s => {
                        let [d, m, y] = s.split(/\D/);
                        return new Date(y, m - 1, d);
                    };
                    return new Date(parseDMY(a.original.dataTimesheet)) - new Date(parseDMY(b.original.dataTimesheet));
                }
            },
            {
                Header: "Lider",
                accessor: "lider",
                className: "text-left",
                inputFilterClass: "60",
                sortDescFirst: true,
            },
            {
                Header: "Analista",
                accessor: "analista",
                className: "text-left",
                inputFilterClass: "60",
                sortDescFirst: true,
            },
            {
                Header: "Seguradora",
                accessor: "cliente.clienteNome",
                className: "text-left",
                inputFilterClass: "80",
                sortDescFirst: true,
            },
            {
                Header: "Etapa da aprovação",
                accessor: "nomeEtapa",
                className: "text-left",
                sortDescFirst: true,
                Filter: StartStringColumnFilter,
                filter: startsWith
            },
            {
                Header: "Segurado",
                accessor: "segurado.seguradoNome",
                className: "text-left",
                inputFilterClass: "90",
                sortDescFirst: true,
            },
            {
                Header: "Status",
                accessor: "statusTimesheet",
                className: "text-center",
                inputFilterClass: "50",
                sortDescFirst: true,
            },

            {
                Header: "Tipo TS",
                accessor: "tipoTimesheet",
                className: "text-center",
                inputFilterClass: "80",
                sortDescFirst: true,
            },
            {
                Header: "Horas",
                accessor: "horasTimeSheet",
                className: "text-right",
                classNameFooter: "text-right legend-value",
                inputFilterClass: "45",
                sortDescFirst: true,
                Cell: (props) => {
                    return <div>{formatDecimal(props.cell.value)}</div>;
                },
                Footer: info => {
                    const total = React.useMemo(
                        () =>

                            info.rows.reduce((sum, row) => convertDecimal(row.original.horasTimeSheet) + sum, 0),
                        [info.rows]
                    )
                    return <>{formatDecimal(total)}</>
                },

            },
            {
                Header: "Valor ",
                accessor: "valorTimesheet",
                className: "text-right",
                classNameFooter: "text-right legend-value",
                filter: 'money',
                inputFilterClass: "96",
                sortDescFirst: true,
                Cell: (props) => {
                    return <div>{props?.row?.original?.valorTotalDesconto > 0 ? "*" : ""} {props.cell.value.toLocaleString('pt-br', { style: 'currency', currency: 'BRL', maximumFractionDigits: 2 })}</div>;
                },
                Footer: info => {
                    const total = React.useMemo(
                        () =>
                            info.rows.reduce((sum, row) => convertDecimal(row.original.valorTimesheet) + sum, 0),
                        [info.rows]
                    )
                    return <> {total.toLocaleString('pt-br', { style: 'currency', currency: 'BRL', maximumFractionDigits: 2 })}</>
                },
                Filter: MoneyColumnFilter,

            },
        ],
        []
    );

    const getClassRow = (row) => {
        return (row.acoes.notificacaoAtividade || row.acoes.notificacaoGrupoAtividade) ? 'notificacaoCard' : row?.acoes?.notificacaoEsclarecimento ? 'esclarecimentoCard' : (row?.atividadesProbono > 0 ? ' probonoCard' : '')
    };

    const getClassRowIndicacao = (row) => {
        return row?.acoes?.indicacao ? 'indicacaoCheck' : ''
        //+ ` ${getClassRowIndicacao(row?.original)}`
    }

    const filterTypes = {
        text: (rows, id, filterValue) => {
            return rows.filter(row => {
                const rowValue = row.values[id];
                return rowValue !== undefined ? String(rowValue).toLowerCase().startsWith(String(filterValue).toLowerCase()) : true;
            });
        }
    };

    const defaultColumn = { Filter: ColumnFilter };
    const {
        getTableProps, // table props from react-table
        getTableBodyProps, // table body props from react-table
        headerGroups, // headerGroups, if your table has groupings
        footerGroups,
        rows, // rows for the table based on the data passed
        prepareRow,
        setColumnOrder
    } = useTable({ columns, data: listTsTable, defaultColumn, filterTypes }, useFilters, useSortBy, useColumnOrder);

    const getHeadTableAccessor = (columnsHead) => {
        let columns = [];
        columnsHead.forEach((column) => {
            columns.push(column.accessor);
        });

        return columns;
    };

    const handleDragEnd = (result) => {
        if (!result.destination) return;
        try {
            const reorderedColumns = getLastConfigOrderColumns();
            const [removed] = reorderedColumns.splice(result.source.index, 1);
            reorderedColumns.splice(result.destination.index, 0, removed);
            setColumnOrder(reorderedColumns);
            saveLastColumns(reorderedColumns);

        } catch (error) {
            console.log(error);
        }

    };

    const saveLastColumns = (columns) => {

        if (columns?.length === 0) {
            return;
        }

        localStorage.setItem('columnsTsAp', JSON.stringify(columns));
    };

    const getLastConfigOrderColumns = () => {
        const columnsN = localStorage.getItem('columnsTsAp');
        if (columnsN) {
            var columnsInStorage = JSON.parse(columnsN)
            if(columnsInStorage.length != deafultOrderColumns.length) {
                columnsInStorage.splice(3, 0, "vidaUtil")
                saveLastColumns(columnsInStorage);
            }
            return columnsInStorage;
        }
        return deafultOrderColumns;
    }

    const loadingLastConfigCollumns = () => {

        const columnsN = getLastConfigOrderColumns();
        if (columnsN) {
            setColumnOrder(columnsN);
        }
    };

    const resetColuns = () => {
        setColumnOrder(deafultOrderColumns);
        saveLastColumns(deafultOrderColumns);
    }

    useEffect(() => {
        setTimeout(() => {
            loadingLastConfigCollumns();
        }, 1000);
    }, []);

    useEffect(() => {

        listTsTable = [];
        setListTsTable([]);

        if (listaAprovacoes?.data?.itens?.length > 0) {
            listTsTable = listaAprovacoes?.data?.itens
            setListTsTable(listaAprovacoes?.data?.itens);
        }

    }, [listaAprovacoes]);

    useEffect(() => {
        checkedList = [];
    }, [clearCheckedList]);

    // Contexto de aprovação em massa
    const onChangeSetAprovacaoEmMassa = (isChecked, row) => {
        if (isChecked) {
            checkedList = checkedList.find(id => id === row.idPendenciaAprovacao) ? checkedList : [...checkedList, row.idPendenciaAprovacao];
            setAprovacaoEmMassaList(prev =>
                prev.find(r => r.idPendenciaAprovacao === row.idPendenciaAprovacao) ? prev : [...prev, row]
            );
        } else {
            checkedList = checkedList.filter(id => id !== row.idPendenciaAprovacao)
            setAprovacaoEmMassaList(prev =>
                prev.filter(r => r.idPendenciaAprovacao !== row.idPendenciaAprovacao)
            );
        };
    }

    const isChecked = (idPendenciaAprovacao) => {
        return checkedList.find(id => id === idPendenciaAprovacao) ? true : false;
    }

    const filterRow = (row) => {
        return !row.acoes.notificacaoAtividade &&
            row.escalrecimentosEmAberto === 0 &&
            row.statusAprovacao === 'Pendente' &&
            !row?.acoes?.notificacaoGrupoAtividade
    };

    const setAllAprovacaoEmMassaList = (isChecked) => {
        const allRows = listaAprovacoes?.data?.itens.filter(item => filterRow(item));
        const allRowsId = allRows.map(item => item.idPendenciaAprovacao);

        if (isChecked) {
            checkedList = allRowsId;
            setAprovacaoEmMassaList(allRows);
        }else {
            checkedList = [];
            setAprovacaoEmMassaList([]);
        }
    }

    return (
        (
            <StyledTableAprovacoes>
                <div className=" timesheet">
                {rows?.length > 0 && (
                    <>
                        <button
                            className="btn btn-xs pull-left collumResetBtn"
                            onClick={resetColuns}
                            title="reset configuração personalizada das colunas"
                        >
                            <IconTable />
                        </button>

                        {aprovacaoEmMassa && (
                            <>
                                <input
                                    className="collumAprovarBtn default-button-red mx-1 mt-2"
                                    value="Aprovação em Massa"
                                    type="button"
                                    onClick={() => openModalAprovacaoEmMassa()}
                                />
                                <button
                                    className={`collumAprovarAllBtn ${checkAll ? 'ativo' : ''}`}
                                    onClick={() => {
                                        var isChecked = checkAll;

                                        setCheckAll(!checkAll);
                                        setAllAprovacaoEmMassaList(!isChecked);
                                    }}
                                    title="marcar todas as aprovações"
                                >
                                    <i className="fa fa-check-circle-o"></i>
                                </button>
                            </>
                        )}
                    </>
                )}
                    <DragDropContext onDragEnd={handleDragEnd}>
                        <Droppable droppableId="columns-droppable-ap" direction="horizontal">
                            {(provided) => (
                                <StyledTablePage>
                                    <div className="table-container table-container-aprovacoes">
                                        <table
                                            ref={provided.innerRef}
                                            {...provided.droppableProps}
                                            {...getTableProps()}
                                            className="table table-bordered table-width table-sm"
                                        >
                                            <thead>
                                                {headerGroups.map((headerGroup) => (
                                                    <tr {...headerGroup.getHeaderGroupProps()} key={headerGroup.id}>
                                                        {headerGroup.headers.map((column, index) => (
                                                            <Draggable
                                                                key={'TsTabH' + index}
                                                                draggableId={'TsDraggableId' + index}
                                                                index={index}
                                                            >
                                                                {(provided) => (
                                                                    <th
                                                                        {...column.getHeaderProps(
                                                                            column.getSortByToggleProps()
                                                                        )}
                                                                        ref={provided.innerRef}
                                                                        {...provided.draggableProps}
                                                                        {...provided.dragHandleProps}
                                                                        className={`${column?.classnameHeader} align-middle text-center`}
                                                                    >
                                                                        {column.render("Header")}
                                                                        <span style={{ marginLeft: "3px" }}>
                                                                            {column.isSorted ? (
                                                                                column.isSortedDesc ? (
                                                                                    <svg
                                                                                        width="12px"
                                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                                        viewBox="0 0 320 512"
                                                                                    >
                                                                                        <path d="M182.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8l256 0c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128z" />
                                                                                    </svg>
                                                                                ) : (
                                                                                    <svg
                                                                                        width="12px"
                                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                                        viewBox="0 0 320 512"
                                                                                    >
                                                                                        <path d="M182.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l256 0c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z" />
                                                                                    </svg>
                                                                                )
                                                                            ) : null}
                                                                        </span>
                                                                        <div>
                                                                            {column.canFilter
                                                                                ? column.render("Filter")
                                                                                : null}
                                                                        </div>
                                                                    </th>
                                                                )}
                                                            </Draggable>
                                                        ))}
                                                    </tr>
                                                ))}
                                            </thead>
                                            <tbody {...getTableBodyProps()}>
                                                {rows && rows.length > 0 ? rows.map((row, i) => {
                                                    prepareRow(row);
                                                    return (
                                                        <tr {...row.getRowProps()} className={`table-data-info`} >
                                                            {
                                                                row.cells.map((cell, i) => {
                                                                    return (
                                                                        <td {...cell.getCellProps()} className={`${cell.column.className} ${getClassRow(row?.original)} `}>
                                                                            <div className={`${(row?.cells[i].column?.tag && 'badge badge-secondary')}` + ` ${row?.cells[i].column?.className}`}>
                                                                                {cell.render("Cell")}
                                                                            </div>
                                                                        </td>
                                                                    );
                                                                })}
                                                        </tr>
                                                    );
                                                }) :
                                                    <tr>
                                                        <td colSpan={columns[0]?.columns?.length ?? 14} className="text-center">
                                                            <div className="alert alert-warning" role="alert">
                                                                Atenção! Aprovação não foi encontrada. Por favor, verifique os dados da pesquisa ou menu TimeSheet.
                                                            </div>
                                                        </td>
                                                    </tr>}
                                            </tbody>
                                            <tfoot>
                                                {rows && rows.length > 0 ? footerGroups.map((footerGroup) => (
                                                    <tr {...footerGroup.getFooterGroupProps()} >
                                                        {footerGroup.headers.map((cell, i) => {
                                                            if (cell.accessor) {
                                                                return (
                                                                    <td className={`${cell?.classNameFooter}`} >{cell.Footer && cell.render('Footer')}</td>
                                                                );
                                                            }

                                                        })}
                                                    </tr>
                                                )) : null}
                                            </tfoot>
                                        </table>
                                    </div>
                                    {provided.placeholder}
                                </StyledTablePage>
                            )}
                        </Droppable>
                    </DragDropContext>
                </div >
                <ModalTimesheetFinalizar
                    isOpen={modalTimeshetFinalizarIsOpen}
                    onRequestClose={closeModalTimesheetFinalizar}
                    ariaHideApp={false}
                    timesheet={timesheet}
                    finalizarResumo={finalizarResumo}
                    finalizarResumoAccess={finalizarResumoAccess}
                    disableButtons={true}
                >
                </ModalTimesheetFinalizar>
            </StyledTableAprovacoes >
        )
    );

    // return (
    //     (
    //         <StyledTableAprovacoes>
    //             <div className=" timesheet">
    //                 <StyledTablePage>
    //                     <div className="table-container">
    //                         <table {...getTableProps()} className="table table-bordered table-width table-sm">
    //                             <thead>
    //                                 {headerGroups.map((headerGroup) => (
    //                                     <>
    //                                         <tr {...headerGroup.getHeaderGroupProps()} key={headerGroup.id}>
    //                                             {headerGroup.headers.map((column) => {
    //                                                 return column.hideHeader === false ? null : (
    //                                                     <th {...column.getHeaderProps(column.getSortByToggleProps())} className={`${column?.classnameHeader}`}>
    //                                                         {column.render("Header")}
    //                                                         <span style={{ marginLeft: '3px' }}>
    //                                                             {
    //                                                                 column.isSorted
    //                                                                     ? column.isSortedDesc
    //                                                                         ? <svg width="12px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M182.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l256 0c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z" /></svg>
    //                                                                         : <svg width="12px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M182.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8l256 0c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128z" /></svg>
    //                                                                     : null
    //                                                             }
    //                                                         </span>
    //                                                     </th>
    //                                                 );
    //                                             }
    //                                             )}
    //                                         </tr >
    //                                         <tr {...headerGroup.getHeaderGroupProps()}>
    //                                             {headerGroup.headers.map((column) => {
    //                                                 return column.hideHeader === false ? null : (
    //                                                     <th className={`${column?.classnameHeader}`}>
    //                                                         <div>{column.canFilter ? column.render("Filter") : null}</div>
    //                                                     </th>
    //                                                 );
    //                                             }
    //                                             )}
    //                                         </tr>
    //                                     </>
    //                                 ))}
    //                             </thead>
    //                             <tbody {...getTableBodyProps()}>
    //                                 {rows && rows.length > 0 ? rows.map((row, i) => {
    //                                     prepareRow(row);
    //                                     return (
    //                                         <tr {...row.getRowProps()} className={`table-data-info `} >

    //                                             {

    //                                                 row.cells.map((cell, i) => {
    //                                                     return (
    //                                                         <td {...cell.getCellProps()} className={`${cell.column.className} ${getClassRow(row?.original)}`}>
    //                                                             <div className={`${(row?.cells[i].column?.tag && 'badge badge-secondary')}` + ` ${row?.cells[i].column?.className}`}>
    //                                                                 {cell.render("Cell")}
    //                                                             </div>
    //                                                         </td>
    //                                                     );
    //                                                 })}
    //                                         </tr>
    //                                     );
    //                                 }) :
    //                                     <tr>
    //                                         <td colSpan={columns[0]?.columns?.length ?? 12} className="text-center">
    //                                             <div className="alert alert-warning" role="alert">
    //                                                 Atenção! Aprovação não foi encontrada. Por favor, verifique os dados da pesquisa ou menu TimeSheet.
    //                                             </div>
    //                                         </td>
    //                                     </tr>}
    //                             </tbody>
    //                             <tfoot>
    //                                 {rows && rows.length > 0 ? footerGroups.map((footerGroup) => (
    //                                     <tr {...footerGroup.getFooterGroupProps()} >
    //                                         {footerGroup.headers.map((cell, i) => {
    //                                             if (cell.accessor) {
    //                                                 return (
    //                                                     <td className={`${cell?.classNameFooter}`} >{cell.Footer && cell.render('Footer')}</td>
    //                                                 );
    //                                             }

    //                                         })}
    //                                     </tr>
    //                                 )) : null}
    //                             </tfoot>
    //                         </table>
    //                     </div>
    //                 </StyledTablePage>
    //             </div >
    //             <ModalTimesheetFinalizar
    //                 isOpen={modalTimeshetFinalizarIsOpen}
    //                 onRequestClose={closeModalTimesheetFinalizar}
    //                 ariaHideApp={false}
    //                 timesheet={timesheet}
    //                 finalizarResumo={finalizarResumo}
    //                 finalizarResumoAccess={finalizarResumoAccess}
    //                 disableButtons={true}
    //             >
    //             </ModalTimesheetFinalizar>
    //         </StyledTableAprovacoes >

    //     )
    // );

};
